import { render, staticRenderFns } from "./VPS.vue?vue&type=template&id=ebacc524&"
import script from "./VPS.vue?vue&type=script&lang=js&"
export * from "./VPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports